import React from 'react';
import { ExternalLink } from 'lucide-react';
import { JIRA_BASE, severityClass, statusClass } from './fixStatusTableHelpers';

const OPTIONS = [
  { value: 'pu', label: 'PU' },
  { value: 'qt', label: 'QT' },
  { value: 'both', label: 'Both' },
];

const COLUMN_COUNT = 9;

// Issues rejected by QT or by the product units, using the same rule as the Overview's
// "Rejected by QT / PU" boxes, so the row counts match those boxes.
function RejectedTable({ issues, rejectedBy, onRejectedByChange }) {
  return (
    <div>
      <div className="section-header">
        Rejected
        <div className="rejected-by-toggle" role="group" aria-label="Rejected by">
          {OPTIONS.map(({ value, label }) => (
            <button
              key={value}
              type="button"
              className={rejectedBy === value ? 'active' : ''}
              aria-pressed={rejectedBy === value}
              onClick={() => onRejectedByChange(value)}
            >
              {label}
            </button>
          ))}
        </div>
      </div>
      <div className="section-body" style={{ padding: 0 }}>
        {issues == null ? (
          <div style={{ padding: 14, color: 'var(--cmp-text-muted)', fontSize: '0.85rem' }}>Loading…</div>
        ) : (
          <div className="issues-table-wrap">
            <table className="issues-table">
              <thead>
                <tr>
                  <th>Key</th>
                  <th>Title</th>
                  <th>Type</th>
                  <th>Severity</th>
                  <th>Unit</th>
                  <th>Status</th>
                  <th>Resolution</th>
                  <th>Resolved by</th>
                  <th>Rejected by</th>
                </tr>
              </thead>
              <tbody>
                {issues.length === 0 ? (
                  <tr>
                    <td colSpan={COLUMN_COUNT} style={{ color: 'var(--cmp-text-muted)', fontSize: '0.85rem' }}>
                      No rejected issues found.
                    </td>
                  </tr>
                ) : issues.map((issue) => (
                  <tr key={issue.key}>
                    <td>
                      <a href={`${JIRA_BASE}/${issue.key}`} target="_blank" rel="noopener noreferrer">
                        {issue.key} <ExternalLink size={11} style={{ verticalAlign: 'middle', opacity: 0.6 }} />
                      </a>
                    </td>
                    <td>{issue.summary}</td>
                    <td>{issue.issueType || '—'}</td>
                    <td>
                      {issue.severity
                        ? <span className={`issue-type-pill ${severityClass(issue.severity)}`}>{issue.severity}</span>
                        : '—'}
                    </td>
                    <td>{issue.unit || '—'}</td>
                    <td>
                      <span className={`status-chip ${statusClass(issue.status)}`}>{issue.status || '—'}</span>
                    </td>
                    <td>{issue.resolution || '—'}</td>
                    <td>{issue.resolvedBy || '—'}</td>
                    <td>{issue.rejectedBy === 'qt' ? 'QT' : 'PU'}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan={COLUMN_COUNT} style={{ padding: '6px 10px', fontSize: '0.8rem', color: 'var(--cmp-text-muted)', borderTop: '2px solid var(--cmp-border)' }}>
                    {issues.length} {issues.length === 1 ? 'issue' : 'issues'}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default RejectedTable;
